// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"3ad4854a","595":"c4edb185"}[chunkId] + ".chunk.js";
};